import { getData, putData } from "../apiClient";

const ItemName = "CommunicationSettings";
const API_URL = "communication-settings";

/**
 * Fetch the global system communication preferences (Email & Push toggles).
 * Designed to return a nested structure matching your standard React hooks format.
 */
export const GetCommunicationSettings = async () => {
  try {
    const result = await getData(`/${API_URL}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

/**
 * Update the global system communication preferences.
 */
export const UpdateCommunicationSettings = async ({ data }) => {
  try {
    const result = await putData(`/${API_URL}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};
